import React, { useEffect, useState } from "react";
import { getMieter, updateMieterCredentials } from "../api";
import Animation from "../components/Animation";

export default function Einstellungen() {
  const mieterId = localStorage.getItem("mieterId");
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [handy_number, setHandyNumber] = useState("");
  const [abrechnung, setAbrechnung] = useState(null);
  const [briefverkehr, setBriefverkehr] = useState(null);

  const fetchMieterData = async () => {
    const token = localStorage.getItem("token");
    try {
      const mieter = await getMieter(mieterId, token);
      setEmail(mieter.email || "");
      setStreet(mieter.street || "");
      setCity(mieter.city || "");
      setPostalCode(mieter.postal_code || "");
      setHandyNumber(mieter.handy_number || "");
      setAbrechnung(mieter.abrechnung === true ? "ja" : "nein");
      setBriefverkehr(mieter.briefverkehr === true ? "ja" : "nein");
    } catch (error) {
      console.error("Fehler beim Laden des Mieters:", error);
    }
  };

  useEffect(() => {
    if (mieterId) {
      fetchMieterData();
    }
  }, [mieterId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    const formData = {
      email,
      password,
      street,
      city,
      postal_code: postalCode,
      handy_number,
      abrechnung: abrechnung === "ja",
      briefverkehr: briefverkehr === "ja",
    };

    try {
      await updateMieterCredentials(formData, token);
      alert("Daten erfolgreich aktualisiert!");
    } catch (error) {
      console.error(error);
      alert("Fehler beim Speichern. Bitte erneut versuchen.");
    }
  };

  return (
    <div className="form-wrapper">
      <h3 className="form-heading">Einstellungen zur Kommunikation</h3>

      <form onSubmit={handleSubmit} className="settings-form">
        <div className="form-group">
          <label>E-Mail:</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>

        <div className="form-group">
          <label>Neues Passwort (optional):</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>

        <div className="form-group">
          <label>Straße:</label>
          <input type="text" value={street} onChange={(e) => setStreet(e.target.value)} />
        </div>

        <div className="form-group">
          <label>PLZ:</label>
          <input type="text" value={postalCode} onChange={(e) => setPostalCode(e.target.value)} />
        </div>

        <div className="form-group">
          <label>Ort:</label>
          <input type="text" value={city} onChange={(e) => setCity(e.target.value)} />
        </div>

        <div className="form-group">
          <label>Handynummer:</label>
          <input type="text" value={handy_number} onChange={(e) => setHandyNumber(e.target.value)} />
        </div>

        <div className="radio-box">
          <p>📄 PDF-Abrechnungen per Mail?</p>
          <label>
            <input type="radio" name="abrechnung" value="ja" checked={abrechnung === "ja"} onChange={() => setAbrechnung("ja")} />
            Ja
          </label>
          <label>
            <input type="radio" name="abrechnung" value="nein" checked={abrechnung === "nein"} onChange={() => setAbrechnung("nein")} />
            Nein
          </label>

          <p>📬 Briefverkehr per Mail?</p>
          <label>
            <input type="radio" name="briefverkehr" value="ja" checked={briefverkehr === "ja"} onChange={() => setBriefverkehr("ja")} />
            Ja
          </label>
          <label>
            <input type="radio" name="briefverkehr" value="nein" checked={briefverkehr === "nein"} onChange={() => setBriefverkehr("nein")} />
            Nein
          </label>
        </div>

        <button type="submit" className="submit-button">Speichern</button>
      </form>
       <Animation loading={loading}/>
    </div>
  );
}
